import { Button } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface IFooter {
  hasPermissions: boolean
  onClose: () => void
}

const Footer = ({ hasPermissions, onClose }: IFooter) => {
  return hasPermissions ? (
    <>
      <Button type="secondary" onClick={onClose}>
        {i18n.t('common.cancel')}
      </Button>
      <Button submit>{i18n.t('common.create')}</Button>
    </>
  ) : (
    <Button type="primary" onClick={onClose}>
      {i18n.t('common.confirm')}
    </Button>
  )
}

export default Footer
